// Remembers the project the user was last on, so a reload puts them back where
// they were. Cleared on logout, and only ever a hint - the project is checked
// against the server on every load.
const STORAGE_KEY = "maira_active_project";

export function setStoredProjectId(projectId) {
  try {
    if (projectId) {
      localStorage.setItem(STORAGE_KEY, projectId);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  } catch (e) {
    console.log(e);
  }
}

export function getStoredProjectId() {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch (_) {
    return null;
  }
}

export function clearStoredProjectId() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (_) {
    // ignore
  }
}
